import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { Component } from '../../types/ContentStructure'
import ComponentLogo from './ComponentLogo'

interface IComponentIconoItemProps {
    component: Component
    layout?: 'side' | 'center'
}

const ComponentIconoItem: FC<IComponentIconoItemProps> = ({ component, layout = 'side' }) => {
    const { icon, title, components = [] } = component
    const isCenter = layout === 'center'

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textWrap: 'pretty',
            textAlign: 'center',
            gap: { xs: 2, md: 1.75, lg: 2 },
            width: '100%',
            minWidth: 0,
            flex: { xs: '0 1 auto', md: '1 1 0' },
            px: 1,
            py: { xs: 0, md: 0.5 },
            color: 'common.white',
        }}>
            {icon && (
                <Box
                    component="img"
                    src={icon}
                    alt={title || 'Icono regulatorio'}
                    sx={{
                        width: { xs: 52, sm: 48, md: 48, lg: 48 },
                        height: { xs: 52, sm: 48, md: 48, lg: 48 },
                        objectFit: 'contain',
                    }}
                />
            )}

            {title && (
                <Typography
                    variant="body1"
                    sx={{
                        color: 'inherit',
                        lineHeight: { xs: 1.45, md: 1.35, lg: 1.45 },
                        fontSize: {
                            xs: '0.95rem',
                            sm: '1rem',
                            md: isCenter ? '0.84rem' : '0.88rem',
                            lg: isCenter ? '0.92rem' : '0.95rem',
                        },
                    }}
                >
                    {title}
                </Typography>
            )}

            {components.length > 0 && (
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: { xs: 2, md: 2.5 },
                    width: 'fit-content',
                    maxWidth: '100%',
                    px: 1.5,
                    py: 1,
                    borderRadius: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0.92)',
                    boxShadow: '0 12px 28px rgba(0, 0, 0, 0.16)',
                }}>
                    {components.map((logo: Component, index: number) => (
                        <ComponentLogo
                            key={logo.id || index}
                            component={logo}
                            sx={{
                                maxHeight: 32,
                            }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default ComponentIconoItem
